import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const CalendarFilled = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">
      <g id="picto" transform="translate(-668 -150)">
        <circle id="bg" cx="35" cy="35" r="35" transform="translate(668 150)" fill="#c0392b"/>
        <g id="agenda" transform="translate(687.01 167.344)">
          <rect id="Rectangle_1480" data-name="Rectangle 1480" width="30" height="30" rx="2" transform="translate(0.99 4.656)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <line id="Ligne_8" data-name="Ligne 8" y2="7" transform="translate(22.99 0.656)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <line id="Ligne_9" data-name="Ligne 9" y2="7" transform="translate(8.99 0.656)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <line id="Ligne_10" data-name="Ligne 10" x2="30" transform="translate(0.99 14.656)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default CalendarFilled;